/**
 * Directional orbit up (rising spiral) gesture
 * @module gestures/transforms/orbitUp
 */
import { createOrbitGesture } from './orbitFactory.js';
export default createOrbitGesture('up');
